<script lang="ts" setup>
import moment from 'moment'
import GICS from 'gics'
import type { JobItem } from '~/models/Job'
import totalEmployee from '~/assets/data/total-employee.json'

interface Props {
  item: JobItem
}

const props = defineProps<Props>()
const jobDetail = computed(() => props.item as JobItem)
const gicsStructure = ref(jobDetail.value?.company_gics_industry ? new GICS(jobDetail.value?.company_gics_industry.subIndustry) : [])
</script>

<template>
  <div v-if="!isEmpty(jobDetail.company_slug)" class="bg-white rounded-md shadow-sm px-4 lg:px-6 py-6">
    <div class="flex-shrink-0 flex items-center mb-4">
      <img v-if="jobDetail.company_logo" :src="jobDetail.company_logo" class="object-contain w-10 h-10">
      <div v-else class="bg-[#EEF2FF] text-[#4F46E5] text-5xl font-semibold text-center flex items-center w-10 h-10">
        <span class="mx-auto">{{ jobDetail.company_name.charAt(0) }}</span>
      </div>
    </div>
    <div class="text-xl font-bold mb-6">
      About {{ jobDetail.company_name }}
    </div>
    <table class="grid w-full mb-10">
      <tr>
        <td class="font-bold pb-4" width="72px">
          Size
        </td>
        <td class="pb-4">
          {{ totalEmployee.find((item) => item.value === jobDetail?.company_size)?.label || '-' }}
        </td>
      </tr>
      <tr>
        <td class="font-bold pb-4" width="72px">
          Industry
        </td>
        <td class="pb-4">
          <NuxtLink v-if="!isEmpty(gicsStructure)" class="text-[#5843E5]" :to="`/search?st=companies&q=&location=all&industry=${gicsStructure.level(4).name.toLowerCase().replaceAll('&', 'and').replaceAll(' ', '_')}&sort=date`">
            {{ !isEmpty(gicsStructure) ? gicsStructure.level(4).name : '-' }}
          </NuxtLink>
        </td>
      </tr>
      <tr>
        <td class="font-bold pb-4" width="72px">
          Location
        </td>
        <td class="pb-4">
          <span v-if="jobDetail?.company_location?.city || jobDetail?.company_location?.state">{{ jobDetail?.company_location?.city || jobDetail?.company_location?.state }}</span>
          <span v-if="jobDetail?.company_location?.countryName">{{ jobDetail?.company_location?.city || jobDetail?.company_location?.state ? ',' : '' }} {{ jobDetail?.company_location?.countryName }}</span>
          <span v-else>Unknown</span>
        </td>
      </tr>
      <tr>
        <td class="font-bold" width="72px">
          Founded
        </td>
        <td>{{ moment.unix(jobDetail?.company_founder?.date / 1000).format("D MMMM YYYY") }}</td>
      </tr>
    </table>
    <BaseAtomsButton tag="a" outline :href="`/companies/${jobDetail.company_slug}`" size="sm" classes="w-full font-semibold">
      View Company
      <Icon name="mdi:arrow-right" class="w-5 h-5 ml-2" />
    </BaseAtomsButton>
  </div>
</template>
